import { render, staticRenderFns } from "./EditBlockEcwidStoreTabs.vue?vue&type=template&id=c7c95e48&"
import script from "./EditBlockEcwidStoreTabs.vue?vue&type=script&lang=js&"
export * from "./EditBlockEcwidStoreTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports